import React, { useState, useEffect } from 'react';
import Auth from './Auth';
import Chat from './Chat';

const SB_URL = 'https://jzgwqzjnfgbegzyingey.supabase.co';
const SB_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp6Z3dxempuZmdiZWd6eWluZ2V5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY4MTI1MjgsImV4cCI6MjA5MjM4ODUyOH0.7P3bJNpeTumHNjzT0XYJcyG_xd7ObLBGNXwZn24auaw';

export { SB_URL, SB_KEY };

export async function sbAuth(endpoint, body) {
  const r = await fetch(`${SB_URL}/auth/v1/${endpoint}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'apikey': SB_KEY },
    body: JSON.stringify(body)
  });
  return r.json();
}

async function refreshSession() {
  const refreshToken = localStorage.getItem('pm_refresh_token');
  if (!refreshToken) return null;
  const data = await sbAuth('token?grant_type=refresh_token', { refresh_token: refreshToken });
  if (data.access_token) {
    localStorage.setItem('pm_token', data.access_token);
    localStorage.setItem('pm_refresh_token', data.refresh_token);
    if (data.provider_token) localStorage.setItem('pm_google_token', data.provider_token);
    if (data.provider_refresh_token) localStorage.setItem('pm_google_refresh', data.provider_refresh_token);
    return data.access_token;
  }
  return null;
}

export async function sbGet(table, params, token) {
  const qs = new URLSearchParams(params).toString();
  let r = await fetch(`${SB_URL}/rest/v1/${table}?${qs}`, {
    headers: {
      'apikey': SB_KEY,
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  if (r.status === 401) {
    const newToken = await refreshSession();
    if (newToken) {
      r = await fetch(`${SB_URL}/rest/v1/${table}?${qs}`, {
        headers: {
          'apikey': SB_KEY,
          'Authorization': `Bearer ${newToken}`,
          'Content-Type': 'application/json'
        }
      });
    }
  }
  return r.json();
}

export async function sbPost(table, body, token) {
  let r = await fetch(`${SB_URL}/rest/v1/${table}`, {
    method: 'POST',
    headers: {
      'apikey': SB_KEY,
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Prefer': 'return=representation'
    },
    body: JSON.stringify(body)
  });
  if (r.status === 401) {
    const newToken = await refreshSession();
    if (newToken) {
      r = await fetch(`${SB_URL}/rest/v1/${table}`, {
        method: 'POST',
        headers: {
          'apikey': SB_KEY,
          'Authorization': `Bearer ${newToken}`,
          'Content-Type': 'application/json',
          'Prefer': 'return=representation'
        },
        body: JSON.stringify(body)
      });
    }
  }
  return r.json();
}

export default function App() {
  const [session, setSession] = useState(() => {
    const token = localStorage.getItem('pm_token');
    const user = localStorage.getItem('pm_user');
    if (token && user) return { token, user: JSON.parse(user) };
    return null;
  });

  useEffect(() => {
    if (!session) return;
    async function checkAndRefresh() {
      const newToken = await refreshSession();
      if (newToken && newToken !== session.token) {
        setSession(prev => ({ ...prev, token: newToken }));
      } else if (!newToken) {
        handleLogout();
      }
    }
    checkAndRefresh();
    const interval = setInterval(checkAndRefresh, 55 * 60 * 1000);
    return () => clearInterval(interval);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function handleLogin(token, refreshToken, user) {
    localStorage.setItem('pm_token', token);
    localStorage.setItem('pm_refresh_token', refreshToken);
    localStorage.setItem('pm_user', JSON.stringify(user));
    setSession({ token, user });
  }

  function handleLogout() {
    localStorage.removeItem('pm_token');
    localStorage.removeItem('pm_refresh_token');
    localStorage.removeItem('pm_user');
    setSession(null);
  }

  if (!session) return <Auth onLogin={handleLogin} />;
  return <Chat session={session} onLogout={handleLogout} />;
}
